import { IContentViewItem } from '../../../../hooks/api/useContentView';

export const buildAdLegalTooltipText = (adItem: Pick<
    IContentViewItem,
    'erid' | 'teamFullName' | 'teamName' | 'teamInn'
>): string | null => {
    const erid = adItem.erid?.trim();
    const teamFullName = adItem.teamFullName?.trim();
    const teamName = adItem.teamName?.trim();
    const teamInn = adItem.teamInn?.trim();

    const company = teamFullName || teamName || '';
    let details = company;
    if (teamInn) {
        details = details ? `${details}, ИНН ${teamInn}` : `ИНН ${teamInn}`;
    }

    if (erid) {
        return details ? `ERID:${erid}\n${details}` : `ERID:${erid}`;
    }

    return details || null;
};
import { IContentViewItem } from '../../../../hooks/api/useContentView';

export const buildAdLegalTooltipText = (adItem: Pick<
    IContentViewItem,
    'erid' | 'teamFullName' | 'teamName' | 'teamInn'
>): string | null => {
    const erid = adItem.erid?.trim();
    const teamFullName = adItem.teamFullName?.trim();
    const teamName = adItem.teamName?.trim();
    const teamInn = adItem.teamInn?.trim();

    const company = teamFullName || teamName || '';
    let details = company;
    if (teamInn) {
        details = details ? `${details}, ИНН ${teamInn}` : `ИНН ${teamInn}`;
    }

    if (erid) {
        return details ? `ERID:${erid}\n${details}` : `ERID:${erid}`;
    }

    return details || null;
};
